// extracted by mini-css-extract-plugin
export default {"main":"Refs_main__gFYIq","container":"Refs_container__FbhU3","section":"Refs_section__6u4Ip","buttonssection":"Refs_buttonssection__biD7z","error":"Refs_error__M3cjK"};